import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../api/context';
import { Title } from '../../utils/title';
import toast from '../../utils/toast';
import Layout from './Layout';
import styles from './_02_Phone.module.scss';

const _02_Phone = () => {

  const { token } = useAPIContext();
  const [ loading, setLoading ] = useState(false);

  const navigate = useNavigate();

  const next = () => {
    navigate('/wizard/profile');
  };

  useEffect(() => {
    if (!token) {
      return;
    }

    api(token).v1.profile.phone.post()
      .then(res => {
        if (res.status === 200) {
          toast.show(toast.KIND.SUCCESS, 'Confirmation code sent.');
        }
      })
      .catch(err => {
        toast.show(toast.KIND.WARNING, err);
      });
  }, [token]);

  return (
    <>
      <Title value='Phone' />
      <Layout step='phone' auth={true}>
        <div className={styles.root}>

          <Formik
            initialValues={{
              code: '',
            }}
            validationSchema={yup.object({
              code: yup.string()
                .required('Required'),
            })}
            onSubmit={(values, actions) => {

              if (loading) {
                return;
              }

              setLoading(true);

              api(token).v1.profile.phone.confirm
                .post(values)
                .then(res => {
                  setLoading(false);

                  if (res.status === 200) {
                    next();
                  }

                  if (res.status === 400) {
                    toast.show(toast.KIND.ERROR, res.body);
                  }
                })
                .catch(err => {
                  setLoading(false);
                  toast.show(toast.KIND.WARNING, err);
                });

            }} >

            <Form>
              <div>
                <label htmlFor='code'>We sent you a verification code via text message 📱. Please check your phone.</label>
                <Field
                  id='code'
                  aria-label='code'
                  name='code'
                  type='text'
                  disabled={loading}
                />
                <ErrorMessage
                  name='code'
                  component='div'
                />
                <button
                  type='button'
                  disabled={loading}
                  onClick={() => {

                    setLoading(true);

                    api(token).v1.profile.phone.post()
                      .then(res => {
                        setLoading(false);

                        if (res.status === 200) {
                          toast.show(toast.KIND.SUCCESS, 'Confirmation code sent.');
                        }

                        if (res.status === 400) {
                          toast.show(toast.KIND.ERROR, res.body);
                        }
                      })
                      .catch(err => {
                        setLoading(false);
                        toast.show(toast.KIND.WARNING, err);
                      });

                  }}>

                  Re-send Code

                </button>
              </div>

              <button
                type='submit'
                disabled={loading}>

                Confirm

              </button>
            </Form>

          </Formik>

        </div>
      </Layout>
    </>
  );
};

export default _02_Phone;